import React, {useState} from 'react'

const NumberOfDays = () => {

   const [startDate, setStartDate] = useState('');
   const [endDate, setEndDate] = useState('');
   const [countWorkdays, setCountWorkdays] = useState(false);
   const [result, setResult] = useState(null);

   function handleStartDateChange(event) {
      setStartDate(event.target.value);
   }

   function handleEndDateChange(event) {
      setEndDate(event.target.value);
   }

   function handleCountWorkdaysChange(event) {
      setCountWorkdays(event.target.checked);
   }

   function handleCalculateClick() {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const oneDay = 24 * 60 * 60 * 1000;
      let count = Math.round(Math.abs((start - end) / oneDay));
      if (countWorkdays) {
         let workdays = 0;
         for (let i = 0; i < count; i++) {
            const date = new Date(start.getTime() + (i * oneDay));
            if (date.getDay() !== 0 && date.getDay() !== 6) {
               workdays++;
            }
         }
         count = workdays;
      }
      setResult(count);
   }


   return (
      <div className="w-[100%] lg:w-[50%] mx-auto mt-[170px] drop-shadow-xl">
         <h1 className="font-bold text-[30px]">Calculate number of days</h1>
         <h2 className="text-[20px] text-purple-800">Calculate the number of days or workdays between two dates</h2>
         <div className="w-[100%] md:w-[700px] bg-gray-200 mt-[30px] p-[30px] rounded-lg drop-shadow-xl">
            <div className="flex gap-[15px] flex-col md:flex-row justify-between items-center">
               <div className="">
                  <label className="text-[20px] font-medium" htmlFor="start">Start Date</label>
                  <br /><br />
                  <input alue={startDate} onChange={handleStartDateChange} className="outline-none w-[250px] h-[50px] rounded-lg px-[20px]" type="date" name="start" id="" />
               </div>
               <div className="w-[20px] hidden md:block h-[2px] bg-gray-800 translate-y-[30px]"></div>
               <div className="">
                  <label className="text-[20px] font-medium" htmlFor="end">End Date</label>
                  <br /><br />
                  <input value={endDate} onChange={handleEndDateChange} className="outline-none w-[250px] h-[50px] rounded-lg px-[20px]" type="date" name="end" id="" />
               </div>

            </div>
            <div className="border-b-[1px] border-b-gray-400 py-[30px] font-light">
               <input checked={countWorkdays} onChange={handleCountWorkdaysChange} className="mr-[8px]" type="checkbox" id="vehicle1" name="vehicle1" value="count"></input> Count only workdays
            </div>
            <button onClick={handleCalculateClick} className="bg-gradient-to-r from-violet-500 to-indigo-500 hover:opacity-75 text-[20px] w-[210px] mx-auto mt-[30px] rounded-full text-white h-[55px] flex justify-center items-center gap-[10px]">
               Calculate
            </button>
            <div className="py-[30px] flex flex-col gap-[10px] sm:flex-row justify-between">
               <div className="flex sm:flex-col gap-[10px]">
                  <div className="text-[20px] font-medium">Total work days</div>
                  <div className="text-[20px] font-medium">{result ? result : "--"}</div>
               </div>
               <div className="sm:text-end font-light text-gray-600">
                  Start and end dates are included
                  <br />
                  <a className="text-blue-500 underline">National holidays </a> are counted as working days
               </div>
            </div>
         </div>
      </div>
   )
}

export default NumberOfDays
